import React from 'react';
import { Link, Container as ChakraContainer, Button, Text, SimpleGrid } from '@chakra-ui/react';
import useGetColors from 'shared/hooks/useGetColors';
import { LayoutsE, PathsE } from 'shared/routes';

interface Props {
  isModal?: boolean;
}

const CHANNEL_URL = 'https://t.me/+GmYNCWPcYIlmY2Fi';
const MANAGER_URL = 'https://t.me/LeadBolid_AI';


const Index = ({ isModal }: Props) => {
  const { brand500, blue800 } = useGetColors();

  const buttonStyles = {
    fontSize: "16px",
    color: "white",
    backgroundColor: "brand.500",
    fontWeight: "600",
    _hover: {
      backgroundColor: "brand.400"
    },
    borderRadius: "8px",
  }

  return (
    <ChakraContainer p={{
      base: isModal ? "0" : "5",
      md: isModal ? "0" : "10",
    }}>
      {!isModal && (
        <Text
          color={blue800}
          bg="inherit"
          borderRadius="inherit"
          fontWeight="bold"
          fontSize="30px"
          _hover={{ color: { blue800 } }}
          _active={{
            bg: 'inherit',
            transform: 'none',
            borderColor: 'transparent',
          }}
          _focus={{
            boxShadow: 'none',
          }}
        >
          🚀 Автоматизация маркетинга с живыми чатами и умными инструментами
        </Text>
      )}
      <div>
        <br />
        <b>1. AI-Генератор диалогов с любым вайбом</b>
        <br />
        Автоматически генерируемые сценарии общения, которые подстраиваются под любую аудиторию и ситуацию — от эмоциональных бесед до аналитических обсуждений.
        <br />
        ✅ Тестирование разных стилей: эмоциональный, экспертный, сторителлинг
        <br />
        ✅ Влияние через доверие, социальное доказательство и вовлечённость
        <br />
        ➡️ Больше доверия → больше конверсий
        <br />
        <br />
        <b>2. Умный Telegram-планировщик + отложенные пуши</b>
        <br />
        Полный контроль над планированием сообщений прямо из Telegram. Поддержка отложенных пушей и запуск тем по расписанию.
        <br />
        ✅ Мгновенный запуск обсуждений
        <br />
        ✅ Идеально для акций и скидок
        <br />
        ➡️ Попадаем в нужный момент — удар по сомнениям
        <br />
        <br />
        <b>3. Индивидуальные воронки в личке с ИИ</b>
        <br />
        Мульти-сообщения от ИИ создают связный диалог, как с живым человеком, с аргументами, которые ведут к решению.
        <br />
        ✅ Встроенная прогревающая воронка
        <br />
        ✅ Лёгкий переход на аккаунт актёра для продолжения общения
        <br />
        ➡️ Не теряем ни одного лида → превращаем в клиента
        <br />
        <br />
        <b>4. Автоматическое добавление актуальных новостей и хайпа</b>
        <br />
        Авто-парсинг заголовков и горячих новостей для создания вовлекающих обсуждений и актуальных контекстов.
        <br />
        ✅ Темы под крипту, финансы, банки
        <br />
        ✅ Мини-кейсы и эмоциональные истории
        <br />
        ➡️ Продаём через актуальные события — клиенты не могут остаться в стороне
        <br />
        <br />
        <b>5. Управление через Google Таблицы</b>
        <br />
        Гибкое редактирование сценариев и полной аналитики в реальном времени.
        <br />
        ✅ Мгновенные правки и вставка новых блоков
        <br />
        ✅ Простой контроль за работой актёров и публикациями
        <br />
        ➡️ Полный контроль, без зависимости от ИТ-команды
        <br />
        <br />
        <b>Бонусы:</b>
        <br />
        СБ и приватность: один клиент — один пул актёров
        <br />
        Гибкость под вашу нишу: от скриптов до поведения персонажей
        <br />
        Поддержка и кастомизация: обновления, отчётность и выгрузки
        <br />
        <br />
        <b>Пример работы:&nbsp;
          <Link color={brand500} href={CHANNEL_URL} target='_blank'>
            CHAT LB_AI
          </Link>
        </b>
        <br />
        <b>Свяжитесь с менеджером:&nbsp;
          <Link color={brand500} href={MANAGER_URL} target='_blank'>
            LeadBolid_AI
          </Link>
        </b>
        <br />
        <SimpleGrid
          mt="5"
          columns={{ base: 1, md: 3 }}
          spacing="3"
          w={{ md: 'max-content' }}
        >
          <Link href={MANAGER_URL} target='_blank'>
            <Button {...buttonStyles}>
              Связаться с менеджером
            </Button>
          </Link>
          <Link href={CHANNEL_URL} target='_blank'>
            <Button {...buttonStyles}>
              Посмотреть пример чата
            </Button>
          </Link>
          <Link href={`${LayoutsE.AUTH}/${PathsE.SIGN_UP}`}>
            <Button {...buttonStyles}>
              Регистрация
            </Button>
          </Link>
        </SimpleGrid>
      </div>
    </ChakraContainer>
  )
}

export default Index;
